<template>
   <div class="domainInput">
    <span>领域：</span>
    <el-select v-model="value" placeholder="请选择" @change="remoteMethod">
      <el-option label="全部" value="">
      </el-option>
      <el-option v-for="(item,index) in options" :key="index" :label="item.name" :value="item.code">
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {
      value: "",
      options: []
    };
  },
  created() {
    this.getDomainList()
  },
  methods: {
    // 获取领域
    getDomainList() {
      var that = this;
      var params = {
        dataType: "domain"
      };
      this.catReq1Service("/api/v1/project/queryDomainList").then(
        function (response) {
          if (!response.success) {
            return;
          }
          that.options = response.result;
        }
      );
    },
    // 领域select事件
    remoteMethod(query) {
      this.$emit('setDomain', query)
    },
  },
};
</script>

<style lang="less" scoped>
.domainInput {
  text-align: left;
  & > span {
    font-weight: bold;
    color: #566087;
  }
  /deep/.el-select .el-input {
    width: 200px;
    .el-input__inner {
      background-color: #F9F9F9;
      color: #343434;
    }
  }
}
</style>
